<template>
  <div class="pdf_css">
    <div class="flushed_css" v-if="file_show_">
      <i class="el-icon-refresh-right flushed_icon" @click="refurbishing"></i>
    </div>
    <div
      style="min-height: calc(100vh - 0px)"
      v-loading="loading"
      element-loading-text=""
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgb(74 74 74)"
    >
      <iframe
        @load="frm"
        :src="file"
        width="100%"
        style="height: calc(100vh - 0px) !important"
        id="pdf-box"
        v-if="file_show"
      ></iframe>
    </div>

    <!--  v-if="file_show" -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      file: "",
      file_copy: "",
      file_show: false,
      file_show_: false,
      loading: false,
      // frm: false,
    };
  },
  created() {
    // console.log('aaaaaa',this.$route.query.file)
    // "https://eastrans.newacademic.net/pdf/pdffy/pdf2/index.html?file="
    // this.file =
    //   "https://eastrans.newacademic.net/pdf/pdffy/pdf2/index.html?file=" +
    //   'https://eastrans.newacademic.net/pdfResult/online_file/5a6147dc-1cfe-4fd1-afb1-7f44eddeaf87/5a6147dc-1cfe-4fd1-afb1-7f44eddeaf87.pdf' +
    //   "&language=" +
    //   this.$route.query.langTo;
    this.file =
      "/pdf/pdffy/pdf2/index.html?file=" +
      this.$route.query.file +
      "&language=" +
      this.$route.query.langTo;
    this.file_copy =
      "https://eastrans.newacademic.net/pdf/pdffy/pdf2/index.html?file=" +
      this.$route.query.file;
    console.log("this.file", this.file);
    let file_ =
      "http://127.0.0.1:5501/pdffy/pdf2/index.html?file=" +
      "http://problem-feedback-system-img.oss-cn-beijing.aliyuncs.com/1.pdf?OSSAccessKeyId=LTAI4GCAEkRWxrS2Yqd2pSPk&Expires=1733233749&Signature=vqiceqtub4266xuhqyEcabhIbxY%3D" +
      "&language=" +
      this.$route.query.langTo;
    console.log(file_);
    this.$nextTick(function () {
      this.reloads();
    });
    this.confirm_();
    // this.$message({
    //   type: "warning",
    //   message: "本功能为体验功能,如出现无法翻译的情况，请点击右上角刷新",
    // });
  },
  methods: {
    confirm_() {
      this.$alert("本功能为体验功能,如出现无法翻译的情况，请点击右上角刷新", {
        confirmButtonText: "确定",
        type: "warning",
        callback: (action) => {
          // this.$message({
          //   type: 'info',
          //   message: `action: ${ action }`
          // });
        },
      });
    },
    reloads() {
      this.file_show = false;
      this.$nextTick(function () {
        this.file_show = true;
        //
        setTimeout(() => {
          // 在这里编写需要延迟执行的代码
        }, 300);
      });
    },
    refurbishing() {
      this.file_show_ = false;
      this.loading = false;
      this.reloads();
      // this.frm = true;
      // this.file =
      //   "https://eastrans.newacademic.net/pdf/pdffy/pdf2/index.html?file=";
      // this.$nextTick(function () {
      //   this.file = this.file_copy;
      // });
    },
    frm() {
      this.file_show_ = true;
      this.loading = false;
      // let iframeBox = document.getElementById("pdf-box");
      // let internalIframe =
      //   iframeBox.contentWindow.document.querySelector("iframe");
      // if (internalIframe) {
      //   internalIframe.style.height = "500px"; // Adjust the height as needed
      // }
    },
  },
};
</script>

<style lang='less' scoped>
.pdf_css {
  background-color: rgb(74 74 74);
}
// /deep/
.flushed_css {
  // position: relative;
}
.flushed_icon {
  position: absolute;
  top: 6px;
  right: 215px;
  color: rgb(255, 255, 255);
  font-size: 21px;
  cursor: pointer;
}
.flushed_icon:hover {
  // color: #868686;
}
/deep/ #flushed_c {
  display: none !important;
}
</style>
<style >
iframe {
  height: 500px !important;
}
#flushed_c {
  display: none !important;
}
</style>